import { useListAssetGroupsQuery } from '@casops/store/apis/assetGroupsApi';
import { VdsChip } from '@volt/volt-extended-components-react';
import { ReactNode, useMemo } from 'react';
import Skeleton from 'react-loading-skeleton';

interface UseAssetGroupChipsProps {
  assetGroups?: number[];
}

export const useAssetGroupChips = ({ assetGroups }: UseAssetGroupChipsProps): ReactNode => {
  const { data: vehicleGroups, isLoading } = useListAssetGroupsQuery(undefined, {
    refetchOnMountOrArgChange: 60,
  });

  return useMemo(() => {
    if (assetGroups === undefined || isLoading) {
      return <Skeleton width="100px" height="26px" />;
    }

    if (vehicleGroups && assetGroups) {
      const orderedGroups: [number, string][] = [];

      assetGroups.forEach(id => {
        const match = vehicleGroups.find(g => g.id === id);
        if (match?.name) {
          orderedGroups.push([match.id, match.name]);
        }
      });

      // Ensure in alphabetical order
      return orderedGroups
        .sort((a, b) => a[1].localeCompare(b[1]))
        .map(g => <VdsChip key={g[0]} active={false} value={g[1]} />);
    }

    return null;
  }, [assetGroups, vehicleGroups, isLoading]);
};
